import React from 'react'
import styled, { css } from 'styled-components'

export const Button = styled.button`
	/* Adapt the colours based on primary prop */
	background: ${props => props.primary ? '#4078c0' : 'white'};
	color: ${props => props.primary ? 'white' : '#4078c0'};
	font-size: 0.9em;
  margin-top: 0.5em;
	padding: 0.4em 0.75em;
	border: 2px solid #4078c0;
	border-radius: 3px;
	
	&:hover {
    background: ${props => props.primary ? '#fff' : '#4078c0' };
	  color: ${props => props.primary ? '#4078c0' : '#fff'};
  }
`;



// WEBPACK FOOTER //
// ./src/components/Button.js